import { Box, Card, Stack, Typography } from "@mui/material";
import { ConfigProvider, DatePicker, Form, Select, Button, Table } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { getData, postData } from "../utils/lccmServices";
import { notiError } from "../utils/notiUltils";
import dayjs from "dayjs";
import { blue } from "@mui/material/colors";
import Swal from "sweetalert2";
import ExportTable from "../components/ExportTable";
//import "dayjs/locale/th";
//dayjs.locale("th");

function Alarms() {
  const [masterLoading, setMasterLoading] = useState(true);
  const [categoriesData, setCategoriesData] = useState([]);
  const [alarmData, setAlarmData] = useState([]);
  const [vehicleData, setVehicleData] = useState([]);
  const [reportLoading, setReportLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  const onFinish = async (values) => {
    if (values.dateEnd.diff(values.dateStart, "second") < 0) {
      notiError({ message: "ระบุช่วงเวลาไม่ถูกต้อง !", position: "center" });
      return;
    }
    if (values.dateEnd.diff(values.dateStart, "day") > 31) {
      Swal.fire({
        title: "ช่วงระยะเวลาของการออกรายงาน ต้องไม่เกิน 31 วัน !",
        //text: "ช่วงระยะเวลาของการออกรายงาน ต้องไม่เกิน 31 วัน !",
        icon: "warning",
        iconColor: blue[300],
        confirmButtonText: "ตกลง",
        confirmButtonColor: blue[500],
      });
      //notiError({ message: "โปรดตรวจสอบช่วงเวลาของการออกรายงาน เวลาเริ่มต้น - เวลาสิ้นสุด ต้องไม่เกิน 31 วัน !", position: "center" });
      return;
    }
    setDataSource([]);
    setReportLoading(true);
    const params = {
      alarms: values.alarms,
      categories: values.categories,
      vehicles: values.vehicles,
      dateStart: values.dateStart.startOf("date").format("YYYY-MM-DD HH:mm:ss"),
      dateEnd: values.dateEnd.endOf("date").format("YYYY-MM-DD HH:mm:ss"),
    };
    //console.log(params);

    try {
      const data = await postData("/reportAlarms", true, params);
      //console.log(data);
      setDataSource(data);
      setDateStart(values.dateStart);
      setDateEnd(values.dateEnd);
    } catch (err) {
      console.error(err);
      notiError({ message: err, position: "center" });
    }

    setReportLoading(false);
  };

  useEffect(() => {
    async function fecthCategories() {
      try {
        const data = await getData("/masterForReportAlarm", true);
        setCategoriesData(
          data.categories.map((a) => {
            return { value: a.CategoryID, label: a.CategoryName };
          })
        );
        setAlarmData(
          data.alarms.map((a) => {
            return { value: a.AlarmID, label: a.AlarmName };
          })
        );
        setVehicleData(
          data.vehicles.map((a) => {
            return { value: a.VehicleID, label: a.VehicleName };
          })
        );
        setMasterLoading(false);
      } catch (err) {
        console.error(err);
        notiError({ message: err, position: "center" });
      }
    }
    fecthCategories();
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "kanit",
          //colorBgContainer: "transparent",
        },
      }}
    >
      <Card
        elevation={0}
        variant="outlined"
        sx={{ bgcolor: blue[100], mt: 1.5 }}
      >
        <Box sx={{ p: 2 }}>
          <Form disabled={reportLoading} onFinish={onFinish} autoComplete="off">
            <Stack direction={"row"} spacing={2}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: (
                      <Typography
                        variant="caption"
                        sx={{ fontStyle: "italic" }}
                      >
                        โปรดระบุวันที่เริ่มต้น
                      </Typography>
                    ),
                  },
                ]}
                name="dateStart"
                style={{ flexGrow: 1, maxWidth: 200 }}
              >
                <DatePicker
                  size="large"
                  placeholder="จากวันที่"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: (
                      <Typography
                        variant="caption"
                        sx={{ fontStyle: "italic" }}
                      >
                        โปรดระบุวันที่สิ้นสุด
                      </Typography>
                    ),
                  },
                ]}
                name="dateEnd"
                style={{ flexGrow: 1, maxWidth: 200 }}
              >
                <DatePicker
                  size="large"
                  placeholder="ถึงวันที่"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                name="categories"
                style={{ flexGrow: 1, minWidth: 100 }}
              >
                <Select
                  loading={masterLoading}
                  options={categoriesData}
                  placeholder="หมวดหมู่"
                  size="large"
                  allowClear
                  mode="multiple"
                  maxTagCount="responsive"
                  style={{ width: "100%" }}
                  optionFilterProp="label"
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                />
              </Form.Item>
              <Form.Item name="alarms" style={{ flexGrow: 1, minWidth: 100 }}>
                <Select
                  placeholder="การแจ้งเตือน"
                  size="large"
                  loading={masterLoading}
                  options={alarmData}
                  allowClear
                  mode="multiple"
                  maxTagCount="responsive"
                  style={{ width: "100%" }}
                  optionFilterProp="label"
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                />
              </Form.Item>
              <Form.Item name="vehicles" style={{ flexGrow: 1, minWidth: 100 }}>
                <Select
                  placeholder="ทะเบียน"
                  size="large"
                  loading={masterLoading}
                  options={vehicleData}
                  mode="multiple"
                  maxTagCount="responsive"
                  style={{ width: "100%" }}
                  allowClear
                  optionFilterProp="label"
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                />
              </Form.Item>
              <Form.Item style={{ flexGrow: 1, maxWidth: 120 }}>
                <Button
                  style={{ width: "100%" }}
                  size="large"
                  type="primary"
                  htmlType="submit"
                  icon={<SearchOutlined />}
                  loading={reportLoading}
                >
                  ค้นหา
                </Button>
              </Form.Item>
            </Stack>
          </Form>
        </Box>
      </Card>

      <Card
        elevation={0}
        variant="outlined"
        sx={{ bgcolor: blue[100], mt: 1.5 }}
      >
        <Box sx={{ p: 2 }}>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Typography mb={2} variant="subtitle2" fontWeight={700}>
              ตารางแสดงข้อมูลการแจ้งเตือน
            </Typography>
            <Box mt={-0.5}>
              <ExportTable
                data={dataSource}
                fileName="alarm_"
                reportName="ตารางแสดงข้อมูลการแจ้งเตือน"
                timeRange={(dateStart, dateEnd)}
                columns={[
                  { title: "วันที่ - เวลา", dataIndex: "Datetime" },
                  { title: "ทะเบียน", dataIndex: "VehicleName" },
                  { title: "แจ้งเตือน", dataIndex: "AlarmName" },
                  { title: "สถานที่", dataIndex: "LocationName" },
                  { title: "หมวดหมู่", dataIndex: "CategoryName" },
                  { title: "ละติจูด", dataIndex: "Latitude" },
                  { title: "ลองจิจูด", dataIndex: "Longitude" },
                  { title: "ความเร็ว", dataIndex: "Speed" },
                ]}
              />
            </Box>
          </Box>

          <TableData loading={reportLoading} dataSource={dataSource} />
        </Box>
      </Card>
    </ConfigProvider>
  );
}

export default Alarms;

function TableData({ loading, dataSource }) {
  /*const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");*/
  /*const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };*/
  /*const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });*/

  return (
    <Table
      bordered
      loading={loading}
      size="small"
      columns={[
        {
          title: "ลำดับ",
          render: (a) => parseInt(a.key) + 1,
          align: "center",
          width: 120,
        },
        {
          title: "วัน - เวลา ",
          render: (a) =>
            dayjs(a.GpsDatetime).utc().format("YYYY-MM-DD HH:mm:ss"),
          sorter: (a, b) => (a.GpsDatetime > b.GpsDatetime ? 1 : -1),
          sortDirections: ["descend"],
          showSorterTooltip: false,
        },
        {
          title: "ทะเบียน",
          dataIndex: "VehicleName",
          //...getColumnSearchProps("VehicleName"),
          sorter: (a, b) => (a.VehicleName > b.VehicleName ? 1 : -1),
          showSorterTooltip: false,
          //sortDirections: ['descend'],
        },
        {
          title: "แจ้งเตือน",
          dataIndex: "AlarmName",
          sorter: (a, b) => (a.AlarmName > b.AlarmName ? 1 : -1),
          showSorterTooltip: false,
          width: "15%",
          //...getColumnSearchProps("AlarmName"),
        },
        {
          title: "สถานที่",
          dataIndex: "LocationName",
          width: "18%",
          sorter: (a, b) => (a.LocationName > b.LocationName ? 1 : -1),
          showSorterTooltip: false,
          //...getColumnSearchProps("LocationName"),
        },
        {
          title: "หมวดหมู่",
          dataIndex: "CategoryName",
          sorter: (a, b) => (a.CategoryName > b.CategoryName ? 1 : -1),
          showSorterTooltip: false,
          //...getColumnSearchProps("CategoryName"),
        },
        {
          title: "ละติจูด",
          dataIndex: "Latitude",
          sorter: (a, b) => (a.Latitude > b.Latitude ? 1 : -1),
          showSorterTooltip: false,
          //...getColumnSearchProps("Latitude"),
        },
        {
          title: "ลองจิจูด",
          dataIndex: "Longitude",
          sorter: (a, b) => (a.Longitude > b.Longitude ? 1 : -1),
          showSorterTooltip: false,
          //...getColumnSearchProps("Longitude"),
        },
        {
          title: "ความเร็ว",
          dataIndex: "Speed",
          align: "center",
          width: 110,
          sorter: (a, b) => (a.Speed > b.Speed ? 1 : -1),
          showSorterTooltip: false,
          //...getColumnSearchProps("Speed"),
        },
      ]}
      dataSource={dataSource}
      pagination={{
        showSizeChanger: true,
        defaultPageSize: 20,
        pageSizeOptions: ["20", "50", "100"],
      }}
      //sticky={true}
      //style={{height:'calc(100vh - 459px)',overflow:'auto'}}
      scroll={{ y: `calc(100vh - 480px)` }}
    />
  );
}
